import { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { Row, Col, Button, Overlay, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import ServerSideDataTable from "../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import { Formik, Form } from "formik";
import FormikControl from "../../../layouts/Input/FormikControl";
import { getDropdownList, getDropdownListByPost } from "../../Shared/dropdownListActions";
import axios from "../../../apis/Api";
import { renderCell,renderHeader } from "../../../utilities/FUNCTIONS";
import {
  GET_DISTRIBUTOR_DDL,
  GET_DISTRIBUTIONCENTER_DDL,
  GET_LENDER_DDL,
} from "../../../Types";

import { getLoanKycReport, downloadJob } from "./LoanKycReportActions";
import Moment from "react-moment";
import storage from "../../../apis/Storage";
import { isPermittedPage } from "../../../apis/Utility";
import { formatDate } from "../../../utilities/FUNCTIONS";

const LoanKycReport = (props) => {
  const userRights = JSON.parse(storage.get("_userRights"));
  //Pagination
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchText, setSearchText] = useState("");

  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);

  const [filterDistributorName, setFilterDistributorName] = useState(null);
  const [filterDistributionID, setFilterDistributionID] = useState(null);

  const [filter, setfilter] = useState({
    distributorId: null,
    distCenterId: null,
    vizId: null,
    financier: null,
    kycStatus: null,
    contractStatus: null,
    fromDate: new Date(),
    toDate: new Date(),
    pageNo: 0,
    searchText: null,
    isExport: false,
  });

  const [lenderOptions, setLenderOptions] = useState([]);

  const [addJobDistributorsOptions, setAddJobDistributorsOptions] =
    useState(null);
  const [addJobDistCenterOptions, setAddJobDistCenterOptions] = useState([]);

  const columns = [
    {
      Header: "VIZ ID",
      accessor: "vizId",
    },
    {
      Header: "Shop Name",
      accessor: "shopName",
    },
    {
      Header: "CNIC No.",
      accessor: "cnicNo",
    },
    {
      Header: "Mobile Number",
      accessor: "mobileNumber",
    },
    {
      Header: "Financier",
      accessor: "financier",
    },
    {
      Header: "KYC Status",
      accessor: "kycStatus",
      Cell: ({ value }) => (
        <div>{value === "NeedMoreInfo" ? "Rejected" : value}</div>
      ),
    },
    {
      Header: "Contract Status",
      accessor: "contractStatus",
    },
    {
      Header: renderHeader("Assign Limit"),
      accessor: "assignLimit",
      Cell: ({ value }) => renderCell(value, true),
    },
    {
      Header: "Date",
      accessor: "date",
      Cell: (row) => (
        <div>
          <Moment format="DD/MM/YYYY">{row.value}</Moment>
        </div>
      ),
    },
  ];

  const openFilterModal = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const handleResetFilters = (resetForm) => {
    resetForm();
    setfilter({
      distributorId:
        userRights != null && userRights?.userType == "DistributorUser"
          ? filter.distributor
          : null,
      distCenterId: null,
      vizId: null,
      financier: null,
      kycStatus: null,
      contractStatus: null,
      fromDate: new Date(),
      toDate: new Date(),
      pageNo: 0,
      searchText: null,
      isExport: false,
    });

    setFilterDistributorName(null);
    setFilterDistributionID(null);
    setAddJobDistCenterOptions([]);
  };

  const searchChanged = (text) => {
    setCurrentPageNo(0);
    setSearchText(text);
  };

  const getData = (page) => {
    setCurrentPageNo(page);
    var request = { ...formRequestObject(), pageNo: page };
    fetchReportData(request);
  };

  const pageSizeChanged = (pageSize) => {
    setCurrentPageNo(0);
    setCurrentPageSize(pageSize);
    var request = { ...formRequestObject(), pageSize: pageSize };
    fetchReportData(request);
  };

  const LoadDataByfilter = (event) => {
    setCurrentPageNo(0);
    var request = { ...formRequestObject(), pageNo: 0 };
    fetchReportData(request);
    setShow(false);
  };

  const Download = () => {
    let request = formRequestObject(true);
    props.downloadJob(request);
  };

  function formRequestObject(isExport = false) {
    let requestData = {
      distributorId:
        filterDistributorName == null ? null : filterDistributorName.value,
      distCenterId:
        filterDistributionID == null ? null : filterDistributionID.value,
      vizId: filter.vizId,
      financier: filter.financier?.value,
      kycStatus: filter.kycStatus?.value,
      contractStatus: filter.contractStatus?.value,
      fromDate: filter.fromDate && formatDate(filter.fromDate),
      toDate: filter.toDate && formatDate(filter.toDate),
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText: searchText,
      isExport: isExport,
    };
    if (userRights != null && (userRights?.userType == 'DistributorUser' || userRights?.userType == 'CoreAppUser')) {
      requestData = {
        ...requestData,
        distributorId: userRights?.distributorId,
      };
    }
    return requestData;
  }

  function fetchReportData(request) {
    let finalRequest = request == null ? formRequestObject() : request;
    props.getLoanKycReport(finalRequest);
  }

  useEffect(() => {
    setCurrentPageNo(0);
    fetchReportData();
  }, [searchText]);

  useEffect(() => {
    if (props.LoanKycReport) {
      setTotalRecords(props.LoanKycReport?.totalRecords);
    } else {
      setTotalRecords(0);
    }
  }, [props.LoanKycReport]);

  useEffect(() => {
    props.getDropdownList(
      `api/Distributor/GetDistributorsDDL`,
      GET_DISTRIBUTOR_DDL
    );
  }, []);

  useEffect(() => {
    props.getDropdownList(`api/Lender/GetLendersDDL`, GET_LENDER_DDL);
  }, []);

  useEffect(() => {
    setLenderOptions(
      props.allLenderList.map(function (item) {
        return {
          value: item.value,
          label: item.label,
        };
      })
    );
  }, [props.allLenderList]);

  useEffect(() => {
    if (userRights != null && userRights?.userType == "DistributorUser") {
      let distributorList = props.allDistributorList.filter(
        (x) => x.value == userRights?.distributorId
      );
      setAddJobDistributorsOptions(
        distributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    } else if (userRights != null && userRights?.userType == "CoreAppUser") {
            let distributorList = props.allDistributorList.filter((x) =>
                userRights?.distributorId.includes(x.value)
            );
            setAddJobDistributorsOptions(
                distributorList.map(function (item) {
                return {
                    value: item.value,
                    label: item.label,
                };
                })
            );
            } else {
      setAddJobDistributorsOptions(
        props.allDistributorList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    }
  }, [props.allDistributorList]);

  useEffect(() => {
    if (userRights != null && (userRights?.userType == 'DistributorUser' || userRights?.userType == 'CoreAppUser')) {
      var assignedDistcenterIds = userRights.distCenterIds.split(",");
      let filteredItems = props.addJobDistCentersddlList.filter((item) =>
        assignedDistcenterIds.includes(item.value)
      );
      setAddJobDistCenterOptions(
        filteredItems.map(function (item) {
          return {
            value: item.value,
            label: item.label,
            principalName: item.principalName,
            cityName: item.cityName,
          };
        })
      );
    } else {
      setAddJobDistCenterOptions(
        props.addJobDistCentersddlList.map(function (item) {
          return {
            value: item.value,
            label: item.label,
          };
        })
      );
    }
  }, [props.addJobDistCentersddlList]);

  useEffect(() => {
    if (filterDistributorName) {
      props.getDropdownListByPost(
        `api/DistCenter/GetDistCentersDDL`,
        {distributorIds: filterDistributorName.value},
        GET_DISTRIBUTIONCENTER_DDL
      );
    }
    filter.distCenter = null;
  }, [filterDistributorName]);

  const kycStatusOptions = [
    {
      label: "Pending",
      value: 5,
    },
    {
      label: "Approved",
      value: 6,
    },
    {
      label: "Rejected",
      value: 7,
    },
    {
      label: "Need More Info",
      value: 8,
    },
    {
      label: "Error",
      value: 9,
    }
  ];

  const contractStatusOptions = [
    {
      label: "Pending",
      value: "Pending",
    },
    {
      label: "Approved",
      value: "Approved",
    },
    {
      label: "Rejected",
      value: "Rejected",
    },
  ];

  return (
    <div>
      <VzPageContainer title="Loan Kyc Report">
        <Row>
          <Col style={{ float: "left" }}>
            <h4>
              <b>Loan KYC Report</b>
            </h4>
            <br />
          </Col>
        </Row>
        <Row>
          <Col md={10} style={{ float: "right" }}>
            <div ref={ref}>
              <Button
                onClick={openFilterModal}
                className="m-3"
                variant="outline-primary"
              >
                <i className="fa fa-filter" />
                Filters
              </Button>

              <Overlay
                show={show}
                target={target}
                placement="bottom"
                container={ref}
                containerPadding={20}
                width="430px"
                style={{ width: "430px" }}
              >
                <Popover
                  id="popover-contained"
                  style={{ maxWidth: "360px", width: "360px" }}
                >
                  <Popover.Header as="h3">Filters</Popover.Header>
                  <Popover.Body>
                    <Formik
                      enableReinitialize
                      initialValues={{}}
                      validator={() => ({})}
                      onSubmit={(e) => LoadDataByfilter(e)}
                    >
                      {(formik) => (
                        <Form autoComplete="off">
                          <Row>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Distributor"
                                name="distributorName"
                                options={addJobDistributorsOptions}
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  if (!e || !e.value) {
                                    setFilterDistributionID(null);
                                    setFilterDistributorName(null);
                                    return;
                                  }
                                  setFilterDistributorName({
                                    label: e.label,
                                    value: e.value,
                                  });
                                  setFilterDistributionID(null);
                                }}
                                value={filterDistributorName}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Distribution Center"
                                name="distCenterId"
                                options={addJobDistCenterOptions}
                                isClearable={true}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  if (!e || !e.value) {
                                    setFilterDistributionID(null);

                                    return;
                                  }
                                  setFilterDistributionID({
                                    label: e.label,
                                    value: e.value,
                                  });
                                }}
                                value={filterDistributionID}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                label="Viz ID"
                                name="vizId"
                                handleOnChange={(e) => {
                                  filter.vizId = e;
                                  setfilter({ ...filter, vizId: e });
                                }}
                                value={filter.vizId}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Financier"
                                name="financier"
                                options={lenderOptions}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  if (!e || !e.value) {
                                    return;
                                  }
                                  setfilter({
                                    ...filter,
                                    financier: {
                                      label: e.label,
                                      value: e.value,
                                    },
                                  });
                                }}
                                value={filter.financier}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="KYC Status"
                                name="status"
                                options={kycStatusOptions}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  if (!e || !e.value) {
                                    return;
                                  }
                                  setfilter({
                                    ...filter,
                                    kycStatus: {
                                      label: e.label,
                                      value: e.value,
                                    },
                                  });
                                }}
                                value={filter.kycStatus}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="react-select"
                                label="Contract Status"
                                name="status"
                                options={contractStatusOptions}
                                isSearchable={true}
                                handleOnChange={(e) => {
                                  if (!e || !e.value) {
                                    return;
                                  }
                                  setfilter({
                                    ...filter,
                                    contractStatus: {
                                      label: e.label,
                                      value: e.value,
                                    },
                                  });
                                }}
                                value={filter.contractStatus}
                              />
                            </Col>
                            <Col xs={12} md={6}>
                              <FormikControl
                                // formik={formik}
                                control="date"
                                label="From Date"
                                name="fromDate"
                                handleOnChange={(value) => {
                                  setfilter({ ...filter, fromDate: value });
                                }}
                                value={filter.fromDate}
                              />
                            </Col>
                            <Col xs={12} md={6}>
                              <FormikControl
                                control="date"
                                label="To Date"
                                name="toDate"
                                handleOnChange={(value) => {
                                  setfilter({ ...filter, toDate: value });
                                }}
                                value={filter.toDate}
                              />
                            </Col>
                          </Row>
                          <div className="row" style={{ marginTop: 20 }}>
                            <div className="form-group">
                              <Link
                                onClick={handleResetFilters.bind(
                                  null,
                                  formik.resetForm
                                )}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "left",
                                }}
                              >
                                Reset
                              </Link>
                              <Link
                                onClick={() => {
                                  setShow(false);
                                  setTarget(null);
                                }}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "right",
                                }}
                              >
                                Cancel
                              </Link>
                              <div className="float-right">
                                <Button
                                  type="submit"
                                  className="btn btn-primary"
                                  style={{
                                    marginRight: "10px",
                                    float: "right",
                                  }}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </Popover.Body>
                </Popover>
              </Overlay>
            </div>
          </Col>
          {isPermittedPage("Export", props.actions, props.userRole) && (
            <Col md={2} style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                onClick={Download}
                className="m-3"
                variant="outline-primary"
              >
                <i className="fa fa-download me-1" />
                Export
              </Button>
            </Col>
          )}
        </Row>
        <Row>
          <Col>
            <ServerSideDataTable
              data={props.LoanKycReport?.report ?? []}
              columns={columns}
              getTrProps={(event, data) => null}
              goToPreviousPage={(val) => getData(val)}
              goToNextPage={(val) => getData(val)}
              totalRecords={totalRecords}
              pageSizeChange={(size) => pageSizeChanged(size)}
              myPageSize={currentPageSize}
              myIndex={currentIndex}
              pageNo={currentPageNo}
              searchChanged={searchChanged}
            />
          </Col>
        </Row>
      </VzPageContainer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    allDistributorList: state.ddlList.allDistributorList
      ? state.ddlList.allDistributorList
      : [],

    addJobDistCentersddlList: state.ddlList.selectedDistCentersList
      ? state.ddlList.selectedDistCentersList
      : [],
    allLenderList: state.ddlList.lenderList ? state.ddlList.lenderList : [],
    LoanKycReport: state.LoanKycReport,
  };
};

export default connect(mapStateToProps, {
  getDropdownList,
  getDropdownListByPost,
  getLoanKycReport,
  downloadJob,
})(LoanKycReport);
